import { useQuery } from "@tanstack/react-query";
import axiosManager from "services/axiosManager";

const useGetCurrentCourses = () => {
    const {
        data: courses,
        error,
        isLoading,
    } = useQuery({
        queryKey: ["currentCourses"],
        queryFn: () =>
            axiosManager.get$("/courses/current").then((res) => res.data),
    });

    return { courses, error, isLoading };
};

export default useGetCurrentCourses;
